import { getRuntimeConfig } from "../../config/runtimeConfig";

const resolveTeamPageSize = (size) => {
  if (Number.isFinite(size)) return size;
  const { teamPageSize } = getRuntimeConfig();
  return Number.isFinite(teamPageSize) ? teamPageSize : 1000;
};

export const getTeams = async (api) => {
  return api.get("/api/v1/team", {
    params: { filterTeamMemberTypes: ["SPORTSMAN", "VIEWER"] },
  });
};

export const joinTeam = async (api, { code, token }) => {
  return api.post(
    "/api/v1/team/join",
    { code },
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    },
  );
};

export const getSentTeamJoinRequests = async (api) => {
  return api.get("/api/v1/team-join-request/sent-requests");
};

export const createTeam = async (
  api,
  { name, adminMemberType, pictureFile, token },
) => {
  const formData = new FormData();
  const payload = { name, adminMemberType };
  formData.append(
    "request",
    new Blob([JSON.stringify(payload)], { type: "application/json" }),
  );
  if (pictureFile) {
    formData.append("picture", pictureFile);
  }
  return api.post("/api/v1/team", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

export const updateTeam = async (api, teamId, payload) => {
  return api.upload(`/api/v1/team/${teamId}`, payload);
};

export const updateTeamMember = async (api, teamMemberId, payload) => {
  return api.put(`/api/v1/team-member/${teamMemberId}`, payload);
};

export const removeTeamMember = async (api, teamMemberId) => {
  return api.delete(`/api/v1/team-member/${teamMemberId}`);
};

export const getTeamSessions = async (api, teamPublicId, page = 0, size) => {
  return api.get("/api/v1/team-session", {
    params: { page, size: resolveTeamPageSize(size), teamPublicId },
  });
};

export const deleteTeam = async (api, teamPublicId, token) => {
  return api.delete(`/api/v1/team/${teamPublicId}`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

export const getTeamSessionDetails = async (api, sessionId) => {
  return api.get(`/api/v1/team-session/${sessionId}/details`);
};

export const updateTeamSessionTitle = async (api, sessionId, title) => {
  return api.put(`/api/v1/team-session/${sessionId}`, { title });
};

export const getHiddenTeamSessions = async (
  api,
  teamPublicId,
  page = 0,
  size,
) => {
  return api.get("/api/v1/team-session", {
    params: {
      page,
      size: resolveTeamPageSize(size),
      teamPublicId,
      isHidden: true,
    },
  });
};

export const setTeamSessionHiddenStatus = async (api, sessionIds, isHidden) => {
  return api.put("/api/v1/team-session/hidden-status", {
    sessionIds,
    isHidden,
  });
};
